// import Vue from "vue";
import { createApp } from 'vue'
import i18next from "i18next";
import I18NextVue from "i18next-vue";
import App from "./App.vue";
import messages from './lang/lang'

window.allLang = ['ro', 'en'];

const i18nInitialized = i18next.init({
	lng: 'ro', // sets a default language. Note that if this option is not set, I18next will try to perform language detection automatically and set the locale accordingly
	fallbackLng: 'ro', //says which locale data to use if translations for the currently set language is unavailable
	whitelist: ['ro', 'en'], // says which locales are permitted in this app
	resources: {
		ro: { translation: messages.ro },
		en: { translation: messages.en },
	},
});

i18nInitialized.then(() => createApp(App).use(I18NextVue, { i18next }).mount('#app'));